<template>
	<div v-if="places.length">
		<h3 class="mb-2">Ordenes de trabajo</h3>
		<v-row>
			<v-col cols="12" sm="3" class="my-0 py-0">
				<v-menu v-model="menuOT" :close-on-content-click="false" max-width="290">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							clearable
							dense
							solo
							outlined
							filled
							class="my-3 ml-3"
							label="Seleccione un mes"
							readonly
							v-bind="attrs"
							v-on="on"
							@click:clear="month = null"
							hide-details
							:value="dateFormatted"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="month"
						@change="menuOT = false"
						no-title
						type="month"
						locale="es"
					></v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="2" class="m-0 p-0">
				<v-btn
					class="row-td-block text-capitalize"
					@click="$router.push(`/${month}/resumen-certificados`)"
				>
					Resumen Certificados
				</v-btn>
			</v-col>
			<v-col cols="12" sm="7" class="m-0 p-0"></v-col>

			<v-col cols="12" sm="6">
				<v-text-field
					dense
					filled
					solo
					outlined
					hide-details
					append-icon="mdi-magnify"
					label="Primer filtro"
					v-model="filter1"
				/>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					dense
					filled
					solo
					outlined
					hide-details
					append-icon="mdi-magnify"
					label="Segundo filtro"
					v-model="filter2"
				/>
			</v-col>
		</v-row>
		<div
			v-if="ordersPlaces.length"
			class="mt-2 overflow-y-auto overflow-x-auto work-history"
			style="height: 300px"
		>
			<v-simple-table style="background-color: transparent;">
				<template v-slot:default>
					<thead>
						<tr>
							<th v-for="(header, i) in headers" :key="i" class="text-left">
								{{ header }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, k) in ordersSort" :key="k">
							<td class="text-left caption">{{ item.date }}</td>
							<td class="text-left caption">
								{{ item.person.firstName }} {{ item.person.lastName }}
							</td>
							<td class="text-left caption">{{ item.place }}</td>
							<td class="text-left caption">{{ item.id }}</td>

							<td class="text-left">
								<v-btn
									target="_blank"
									v-if="item.type == 'rrplagas' && !item.isCertificate"
									color="warning"
									rounded
									depressed
									x-small
									class="row-td-block text-capitalize"
									:href="item.certificate"
								>
									Certificar
								</v-btn>
								<v-btn
									target="_blank"
									v-if="item.type == 'rrplagas' && item.isCertificate"
									color="info"
									rounded
									depressed
									x-small
									class="row-td-block text-capitalize"
									:href="item.url"
								>
									Ver OT (Certificada)
								</v-btn>
								<span class="caption info"></span>
								<v-btn
									target="_blank"
									v-if="item.type == 'rrplagas-certificate'"
									color="success"
									rounded
									depressed
									x-small
									class="row-td-block text-capitalize"
									:href="item.url"
								>
									Ver certificado
								</v-btn>
							</td>
							<td>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											v-on="on"
											x-small
											v-bind="attrs"
											color="warning"
											:loading="loadingDownload === k"
											@click="
												downloadPdf(
													item.url,
													`${item.place}-${item.date}-${item.id}`,
													k
												)
											"
										>
											<v-icon small>mdi-download</v-icon>
										</v-btn>
									</template>
									<span>Descargar</span>
								</v-tooltip>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
		<data-empty
			v-else
			:title="`Sin OT's.`"
			:msj="`Selecione un mes diferente o cambie su palabra filtro`"
		/>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Axios from 'axios';
export default {
	name: 'ListWorkOrders',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			menuOT: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
			dialog: false,
			certificateValues: { lodId: '', type: '', index: 0, ot: null },
			filter1: '',
			filter2: '',
			headers: ['Fecha', 'Persona', 'Lugar', 'NºOT', 'Enlace', 'Acción'],
			loadingDownload: '',
		};
	},
	computed: {
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		ordersPlaces() {
			let orders = [];
			this.lodgings.forEach(lod => {
				if (lod.workOrder.length) {
					lod.workOrder.forEach((wo, index) => {
						if (moment(wo[1]).isSame(this.month, 'month'))
							orders.push({
								id: wo.id,
								type: wo.type,
								person: this.getPerson(lod.person),
								lodId: lod._id,
								index: wo.index,
								date: wo.date,
								place: this.getPlaceName(lod.place),
								isCertificate: lod.workOrder.some(
									el => el.id == wo.id && el.type == 'rrplagas-certificate'
								),
								url: this.generateWorkOrderLink(wo.type, lod._id, index),
								certificate: this.generateWorkOrderCertify(wo.type, lod._id, index),
							});
					});
				}
			});

			return orders.sort((a, b) => b.id - a.id);
		},
		ordersSort() {
			let orders = this.ordersPlaces.filter(or => {
				let numOT = 'ot' + or.id;
				let filter1 = true;
				let filter2 = true;
				if (this.filter1) {
					filter1 =
						numOT.indexOf(this.filter1) > -1 ||
						or.type.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1 ||
						or.person.firstName.toLowerCase().indexOf(this.filter1.toLowerCase()) >
							-1 ||
						or.date.indexOf(this.filter1.toLowerCase()) > -1 ||
						or.place.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1;
				}
				if (this.filter2) {
					filter2 =
						numOT.indexOf(this.filter2) > -1 ||
						or.date.indexOf(this.filter2.toLowerCase()) > -1 ||
						or.place.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1 ||
						or.type.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1 ||
						or.person.firstName.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1;
				}
				return filter1 && filter2;
			});
			return orders.sort((a, b) => moment(b.date) - moment(a.date));
		},
		...mapGetters({
			places: 'Place/places',
			lodgings: 'Lodging/lodgings',
			listPerson: 'Person/persons',
		}),
	},
	methods: {
		generateWorkOrderLink(type, lodId, index) {
			return `#/${type}/${lodId}/work-order/${index}`;
		},
		generateWorkOrderCertify(type, lodId, index) {
			return `#/${type}/certificate/${lodId}/work-order/${index}`;
		},
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		getPlaceName(id) {
			if (!this.places.length) return '';
			return this.places.find(place => place._id == id).name;
		},
		async downloadPdf(url, name, id) {
			this.loadingDownload = id;
			url = 'https://rrplagas.kronogram.cl/' + url;
			const response = await Axios(
				`https://southamerica-east1-plhain.cloudfunctions.net/descargarPDF`,
				{ method: 'POST', responseType: 'arraybuffer', data: { url } }
			);
			console.log(url);
			const pdf = response.data;
			const blob = new Blob([pdf], { type: 'application/pdf' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = name + '.pdf';
			link.click();
			this.loadingDownload = '';
		},
	},
};
</script>

<style lang="scss">
.my-table-work {
	th {
		min-width: 90px !important;
	}
	table {
		font-size: 10px !important;
	}
	tbody td {
		height: 30px !important;
	}

	tbody tr:nth-child(odd) {
		background-color: #a78acc24;
	}
}

.row-td-block {
	width: max-content;
}
.center {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
.work-history {
	th {
		min-width: 90px !important;
	}
	table {
		font-size: 10px !important;
	}
	tbody td {
		padding-right: 10px;
		padding-left: 10px;
		height: 10px !important;
	}

	tbody tr:nth-child(odd) {
		background-color: #545fc41c;
	}
}
.row-td-block {
	width: max-content;
}
</style>
